<script>

    import VcPesquisa from '@/components/Form/Pesquisa'
    import VcPaginacao from '@/components/Form/Paginacao.vue'
    import ArmazenaPedido from '@/views/Analises/services/armazenar_pedido'
    import VcMostraMensagemValidacao from '@/components/Form/MostraMensagemValidacao'
    import Datepicker from "@/components/Form/Datepicker";

    export default {
        data() {
            return {
                documento: {label: 'Emitir pedido', value: 'PEDIDO'},
                remetente: null,
                analise: {'valorTotal': 0, 'marcaTodos': false, 'emitir_nota': false},
                analises: [],
                creditosDebitos: [],
                aplicaCredDeb: false,
                valorParcial: 0
            }
        },
        components: {
            VcPesquisa,
            VcPaginacao,
            VcMostraMensagemValidacao,
            Datepicker
        },
        watch: {
            "analise.marcar_todos"(value) {
                if (value) {
                    this.soma()
                } else {
                    this.diminui()
                }
            },

            "aplicaCredDeb"() {
                this.calculaValorParcial()
            }
        },

        computed: {
            extraRemetente() {
                return {
                    cliente: 1,
                    fornecedor: 1
                }
            },

            vaiAgrupar() {
                let analisesAgrupadas = false;

                if (this.analises.length != undefined && this.analises.length > 0) {
                    this.analises.forEach((analise) => {
                        if (analise.agrupar) {
                            analisesAgrupadas = true;
                            return false;
                        }
                    });
                }

                return analisesAgrupadas;
            }
        },

        methods: {
            calculaValorParcial(){
                let valor = this.analise.valorTotal
                if (this.aplicaCredDeb) {
                    let valorCD = (this.somaCreditosDebitos('DEBITO') - this.somaCreditosDebitos('CREDITO'))
                    valor += valorCD
                }
                this.$set(this, 'valorParcial', valor)
            },

            setRemetente(remetente) {
                this.$set(this, 'remetente', remetente);
                let data = new Date()
                let dias = remetente != null && remetente.dias_vencimento_boleto > 0 ? remetente.dias_vencimento_boleto : 30
                data.setDate(data.getDate() + parseInt(dias));
                this.$set(this.analise, "data_vencimento", data.toISOString().substr(0, 10));
                this.$set(this.analise, 'marcar_todos', false)

                this.navigate();
            },
            navigate() {
                this.$http.post('api/analises/listagem/remetente/' + this.remetente.id).then((response) => {
                    this.$set(this, 'creditosDebitos', response.data.creditosDebitos);
                    this.$set(this, 'analises', response.data.analises);
                });
            },

            async realizarAgrupamento() {
                let analises = []

                await this.analises.forEach((analise) => {
                    if (analise.agrupar != undefined && analise.agrupar) {
                        analise.pessoa_id = this.remetente.id
                        analise.boleto = 'REMENTETE'
                        analise.data_vencimento = this.analise.data_vencimento
                        analise.pessoa_id = this.remetente.id
                        analise.emitir_nota = this.analise.emitir_nota
                        analise.forma_pagamento = this.analise.forma_pagamento.value
                        analises.push(analise)
                    }
                })

                let valoresAdicionais = null
                if (this.aplicaCredDeb) {
                    let valorDebito = this.somaCreditosDebitos('DEBITO')
                    let valorCredito = this.somaCreditosDebitos('CREDITO')
                    if ((this.analise.valorTotal + valorDebito) <= valorCredito) {
                        return window.swal('Atenção!', 'Não foi possível armazenar o pedido, valor menor ou igual a zero!', 'warning');
                    }

                    valoresAdicionais = {
                        'debito': valorDebito,
                        'credito': valorCredito
                    }
                }

                this.$validator.validate().then(valid => {
                    if (!valid) {
                        return false;
                    }

                    window.swal({
                        title: 'Armazenando análise',
                        imageUrl: require('@/assets/logo.png'),
                        imageWidth: '100px',
                        animation: false,
                        allowOutsideClick: false,
                        onOpen: () => {
                            window.swal.showLoading();

                            ArmazenaPedido.enviar(analises, null, valoresAdicionais).then(async (res) => {
                                if (res.data.erro == 1) {
                                    return window.swal('Atenção!', 'Não foi possível armazenar o pedido, tente novamente!', 'warning');
                                }
                                window.swal('Sucesso!', 'Análises atualizadas!', 'success');
                                this.navigate();

                                //enviando email
                                this.$http.post("api/enviarAgrupamentoEmail", {'analiseID': this.analises[0].id})

                                if (this.analise.forma_pagamento.value == 'BOLETO') {
                                    await this.$http.get("api/analises/get-boleto/" + this.analises[0].id, {'enviaEmail': true}).then(response => {
                                        let a = document.createElement("a");
                                        a.href = "data:application/octet-stream;base64," + response.data.pdf;
                                        a.download = "Boleto agrupamento de analises.pdf";
                                        a.click();
                                    });
                                }

                                if (this.analise.emitir_nota) {
                                    await this.$http.get("api/analises/get-nfse/" + this.analises[0].id, {'enviaEmail': false}).then(response => {
                                        if (response.data.pdf != null) {
                                            let a = document.createElement("a");
                                            a.href = "data:application/octet-stream;base64," + response.data.pdf;
                                            a.download = "NFS-e agrupamento de analises.pdf";
                                            a.click();
                                        }
                                    });
                                }
                            });
                        }
                    });
                });
            },

            soma() {
                let valorAnalise = 0
                this.analises.forEach((analise, index) => {
                    valorAnalise += parseFloat(analise.valor_amostra);
                    this.$set(this.analises[index], 'agrupar', true)
                });
                this.$set(this.analise, 'valorTotal', valorAnalise);
                this.calculaValorParcial()
            },

            diminui() {
                this.analises.forEach((analise, index) => {
                    this.$set(this.analises[index], 'agrupar', false)
                });
                this.$set(this.analise, 'valorTotal', 0);
                this.calculaValorParcial()
            },

            controlaSomaAnalise(analise) {
                let novoValor = 0
                let valorAnalise = parseFloat(analise.valor_amostra)

                if (!analise.agrupar) {
                    novoValor = this.analise.valorTotal + valorAnalise
                } else {
                    novoValor = this.analise.valorTotal - valorAnalise
                }

                this.$set(this.analise, 'valorTotal', novoValor)
                this.calculaValorParcial()
            },

            somaCreditosDebitos(tipo) {
                let valorTotal = 0
                this.creditosDebitos.forEach((credDeb) => {
                    if (credDeb.operacao == tipo) {
                        valorTotal += parseFloat(credDeb.valor)
                    }
                })
                return valorTotal
            }
        },
        mounted() {
            this.$store.dispatch('setConfiguracao');

            this.$store.dispatch('setTitle', 'Efetuar pagamentos');
        }
    }
</script>

<template>
    <div>
        <div class="block">
            <div class="block-title">
                <h3>Buscar análises</h3>
            </div>
            <div class="row">
                <div class="col-xs-12 col-sm-4">
                    <vc-pesquisa
                            :extra="extraRemetente"
                            @input="setRemetente"
                            label="Remetente"
                            url-busca="api/pessoas/pesquisa"
                            :selecionado-config="{label: 'nomerazao_social', campo: 'id'}"
                            :campos-table="[ {'label' : 'Nome', 'campo' : 'nomerazao_social'}, {'label' : 'CPF/CNPJ', 'campo' : 'cpfcnpj'}]">
                    </vc-pesquisa>
                </div>
            </div>

            <div class="row">
                <vc-mostra-mensagem-validacao></vc-mostra-mensagem-validacao>
            </div>


            <div class="row" v-if="vaiAgrupar">
                <div class="col-xs-12 col-md-4">
                    <div class="form-group" :class="{'has-error': errors.has('forma')}">
                        <label>Forma de pagamento</label>
                        <v-select v-model="analise.forma_pagamento" :options="[
                            {value: 'FATURADA',label: 'Dinheiro / Transferência'},
                            {value: 'BOLETO',label: 'Boleto bancário'}
                        ]" v-validate="'required'" data-vv-name="forma"></v-select>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4"
                     v-if="analise.forma_pagamento != undefined && analise.forma_pagamento.value == 'BOLETO'">
                    <div class="form-group" :class="{'has-error': errors.has('vencimento')}">
                        <label>Vencimento</label>
                        <Datepicker :value="analise.data_vencimento" v-model="analise.data_vencimento"
                                    v-validate="'required'" data-vv-name="vencimento"/>
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <label>Valor das análises</label>
                    <h4>R$ {{ analise.valorTotal | formatMoney}}</h4>
                </div>
            </div>

            <div class="row" v-if="vaiAgrupar">
                <div class="col-xs-6 col-md-4">
                    <div class="form-group">
                        <label class="switch switch-success"><input type="checkbox"
                                                                    v-model="analise.emitir_nota"><span></span></label>&nbsp;Emitir
                        NFS-e
                    </div>
                </div>
            </div>

            <div class="row margin-top-25" v-if="creditosDebitos.length > 0">
                <div class="col-xs-6 col-md-4">
                    <div class="form-group">
                        <label class="switch switch-success"><input type="checkbox"
                                                                    v-model="aplicaCredDeb"><span></span></label>&nbsp;Aplicar
                        créditos / débitos
                    </div>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <label>Valor do crédito</label>
                    <h4 class="text-green">R$ {{ somaCreditosDebitos('CREDITO') | formatMoney}}</h4>
                </div>

                <div class="col-xs-12 col-sm-4">
                    <label>Valor do débito</label>
                    <h4 class="text-danger">R$ {{ somaCreditosDebitos('DEBITO') | formatMoney}}</h4>
                </div>
            </div>

            <div class="row" v-if="aplicaCredDeb">
                <div class="col-xs-12 col-sm-4">
                    <label>Valor a faturar</label>
                    <h4>R$ {{ valorParcial | formatMoney}}</h4>
                </div>
            </div>

            <div class="row" v-if="vaiAgrupar">
                <div class="col-xs-12 col-sm-4">
                    <button class="btn btn-success agrupar" type="button" @click="realizarAgrupamento">
                        Confirmar
                    </button>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12">
                    <table class="table table-hover table-condensed table-striped table-bordered">
                        <thead>
                        <tr role="row">
                            <th width="25%">Proprietários</th>
                            <th width="10%" class="text-center">Tipo</th>
                            <th width="10%" class="text-center">Registro</th>
                            <th width="10%" class="text-center">Tipo</th>
                            <th width="10%" class="text-center">Resultado</th>
                            <th width="10%" class="text-center" @click="ordenar('valor_amostra')">Valor (R$)</th>
                            <th width="10%" class="text-center">
                                <label class="switch switch-success">
                                    <input type="checkbox" v-model="analise.marcar_todos"><span></span>
                                </label>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr role="row" class="even" v-if="analises.length != undefined && analises.length > 0"
                            v-for="(analise) in analises">
                            <td>
                                <div :key="index" v-for="(proprietario, index) in analise.proprietarios"
                                     style="margin-bottom: 7px;">
                                    <span v-if="proprietario.tipo == 1">{{ proprietario.nome }}<br>{{ proprietario.cpf }}</span>
                                    <span v-else>{{ proprietario.razao_social }}<br>{{ proprietario.cnpj }}</span>
                                </div>
                            </td>
                            <td class="text-center">{{analise.tipo }}</td>
                            <td class="text-center">{{analise.registro }}/{{ analise.ano_registro }}</td>
                            <td class="text-center">{{ analise.faturado ? 'Faturada' : 'À prazo' }}</td>
                            <td class="text-center">
                                <div style="margin-bottom: 7px;">
                                    <span v-if="analise.data_resultado_formatada != null">{{ analise.data_resultado_formatada }}</span>
                                </div>
                            </td>
                            <td class="text-center">{{ analise.valor_amostra | formatMoney }}</td>
                            <td class="text-center">
                                <label class="switch switch-success">
                                    <input type="checkbox" v-model="analise.agrupar"
                                           @input="controlaSomaAnalise(analise)"><span></span>
                                </label>
                            </td>
                        </tr>


                        <tr v-if="analises == undefined || (analises.length != undefined && analises.length <= 0)">
                            <td colspan="8" class="text-center margim-bottom-10"><h5 style="font-weight: normal">Nenhum
                                registro encontrado</h5></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>


        </div>
    </div>
</template>

<style>
    .btn.agrupar {
        margin-bottom: 10px;
    }

    .text-green {
        color: green;
    }
</style>
